/** Backend tool-call and activity-log labels (tests/fixtures/activity-labels/tool.json). English equals the fixture exactly. */
export default {
  "tool.reading_file": "Reading file",
  "tool.editing_file": "Editing file",
  "tool.writing_file": "Writing file",
  "tool.finding_files": "Finding files",
  "tool.searching_code": "Searching code",
  "tool.running_command": "Running command",
  "tool.running_command_hint": "Running command: {hint}",
  "tool.checking_command_progress": "Checking command progress",
  "tool.editing_files": "Editing files",
  "tool.asking_question": "Asking a question",
  "tool.updating_plan": "Updating plan",
  "tool.delegating_to_agent": "Delegating to agent",
  "tool.updating_agent": "Updating agent",
  "tool.waiting_for_agent": "Waiting for agent",
  "tool.closing_agent": "Closing agent",
  "tool.checking_agents": "Checking agents",
  "tool.continuing_background_task": "Continuing background task",
  "tool.stopping_agent": "Stopping agent",
  "tool.resuming_agent": "Resuming agent",
  "tool.using_skill": "Using skill",
  "tool.updating_tasks": "Updating tasks",
  "tool.looking_up_tools": "Looking up tools",
  "tool.creating_frame": "Creating frame",
  "tool.updating_frame": "Updating frame",
  "tool.reading_frame": "Reading frame",
  "tool.deleting_frame": "Deleting frame",
  "tool.searching_web": "Searching the web",
  "tool.agent_activity": "Agent activity",
  "tool.fetching_webpage": "Fetching a webpage",
  "tool.running_action": "Running action",
  "tool.running_toolkit_action": "Running {toolkit} action",
  "tool.checking_out_task": "Checking out task",
  "tool.releasing_task": "Releasing task",
  "tool.reading_task": "Reading task",
  "tool.checking_tasks": "Checking tasks",
  "tool.updating_task": "Updating task",
  "tool.creating_task": "Creating task",
  "tool.opening_pr": "Opening PR",
  "tool.checking_runtime": "Checking runtime",
  "tool.checking_chat": "Checking chat",
  "tool.listing_tool_packs": "Listing tool packs",
  "tool.loading_tools": "Loading tools",
  "tool.loading_pack_tools": "Loading {pack} tools",
  "tool.using_tool": "Using tool",
  "tool.reading_selected_text": "Reading selected text",
  "tool.renaming_file": "Renaming file",
  "tool.moving_file": "Moving file",
  "tool.copying_selection": "Copying selection",
  "tool.opening_denker": "Opening Denker",
  "tool.searching_mail": "Searching mail",
  "tool.reading_mail": "Reading mail",
  "tool.replying_to_mail": "Replying to mail",
  "tool.reading_messages": "Reading messages",
  "tool.replying_to_message": "Replying to message",
  "tool.checking_calendar": "Checking calendar",
  "tool.creating_calendar_event": "Creating calendar event",
  "tool.updating_calendar_event": "Updating calendar event",
  "tool.controlling_music": "Controlling music",
  "tool.checking_current_track": "Checking current track",
  "tool.running_tests": "Running tests",
  "tool.checking_code": "Checking code",
  "tool.building_project": "Building project",
  "tool.checking_git": "Checking git",
  "tool.committing_changes": "Committing changes",
  "tool.pushing_changes": "Pushing changes",
  "tool.detail": "{action}: {context}",
  "tool.generic": "{name}",
  "activity.background_task_started": "Background task started",
  "activity.background_task_completed": "Background task completed",
  "activity.background_task_stopped": "Background task stopped",
  "activity.background_task_failed": "Background task failed",
  "activity.background_task_resumed": "Background task resumed",
  "activity.background_task_running": "Background task running",
  "activity.background_task_waiting": "Background task waiting",
  "activity.background_task_queued": "Background task queued",
  "activity.background_task_continued": "Background task continued",
  "activity.background_task_updated": "Background task updated",
  "activity.finished_waiting_for_agent": "Finished waiting for agent",
  "activity.agent_updated": "Agent updated",
  "activity.agent_stopped": "Agent stopped",
  "activity.agent_resumed": "Agent resumed",
  "activity.agent_closed": "Agent closed",
  "activity.agent_progress_checked": "Agent progress checked",
  "activity.coordinating_agents": "Coordinating agents",
  "activity.agent_activity_updated": "Agent activity updated",
  "activity.agent_action_failed": "Agent action failed",
  "activity.agent_action_stopped": "Agent action stopped",
} as const;
